import type { ConversationListItemResponse } from "@redotech/effect-api-shared/models/shopper-ai/conversation/conversation";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

interface EditableAssigneeCellProps {
  conversation: ConversationListItemResponse;
}

/**
 * Editable assignee cell component.
 *
 * NOTE: This is a placeholder implementation. The ConversationListItemResponse
 * currently does not include assignee information (mongoAssigneeId or assignee details).
 *
 * To fully implement this cell, we need to:
 * 1. Add assignee/mongoAssigneeId to ConversationListItemResponse schema
 * 2. Fetch user data to display assignee name/avatar
 * 3. Implement a user picker similar to AssigneePicker from conversation-detail-panel
 *
 * For now, this displays a placeholder message.
 */
export const EditableAssigneeCell = memo(function EditableAssigneeCell({
  conversation: _conversation,
}: EditableAssigneeCellProps) {
  // TODO: Implement once assignee data is available in ConversationListItemResponse
  // const { mutate: updateConversation, isPending } = useUpdateConversation();
  // const team = useRequiredContext(TeamContext);

  return (
    <Text fontSize="xs" textColor="tertiary">
      -
    </Text>
  );
});
